import React from 'react';

const LodgeicAIIcon = ({ size = 24, className = '', withBackground = false }) => {
  const barFill = withBackground ? 'white' : 'url(#lodgeic-ai-gradient)';
  const networkColor = withBackground ? 'rgba(255,255,255,0.7)' : '#fb923c';
  const sparkleColor = withBackground ? 'rgba(255,255,255,0.8)' : '#fb923c';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="lodgeic-ai-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#f97316', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#ea580c', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="lodgeic-bg-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#f5620f', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#ff8c42', stopOpacity: 1 }} />
        </linearGradient>
      </defs>

      {withBackground && (
        <rect
          x="0" y="0" width="32" height="32" rx="8"
          fill="url(#lodgeic-bg-gradient)"
        />
      )}

      <g className="lodgeic-bars">
        <rect x="4" y="20" width="4" height="8" rx="1" fill={barFill} opacity="0.8"/>
        <rect x="10" y="16" width="4" height="12" rx="1" fill={barFill} opacity="0.9"/>
        <rect x="16" y="10" width="4" height="18" rx="1" fill={barFill}/>
        <rect x="22" y="14" width="4" height="14" rx="1" fill={barFill} opacity="0.95"/>
      </g>

      <g className="ai-network" opacity="0.6">
        <line x1="6" y1="22" x2="12" y2="18" stroke={networkColor} strokeWidth="1" strokeLinecap="round"/>
        <line x1="12" y1="18" x2="18" y2="14" stroke={networkColor} strokeWidth="1" strokeLinecap="round"/>
        <line x1="18" y1="14" x2="24" y2="17" stroke={networkColor} strokeWidth="1" strokeLinecap="round"/>
        <circle cx="6" cy="22" r="1.5" fill={networkColor}/>
        <circle cx="12" cy="18" r="1.5" fill={networkColor}/>
        <circle cx="18" cy="14" r="1.5" fill={networkColor}/>
        <circle cx="24" cy="17" r="1.5" fill={networkColor}/>
      </g>

      <g className="ai-sparkle" opacity="0.7">
        <path
          d="M26 6 L27 8 L29 9 L27 10 L26 12 L25 10 L23 9 L25 8 Z"
          fill={sparkleColor}
        />
      </g>
    </svg>
  );
};

export default LodgeicAIIcon;
